import React, { createContext } from 'react';

import {
  IBestOf2025VotingCategory,
  IBestOf2025VotingResponse,
} from '../../hooks/useBestOf2025Voting';

export interface BestOf2025PhaseTwoResourcesInfo {
  currentCategory: IBestOf2025VotingCategory;
  setCurrentCategory: React.Dispatch<React.SetStateAction<IBestOf2025VotingCategory>>;
  categories: IBestOf2025VotingCategory[];
  // Voting guard functions
  selectedResourceIds: string[];
  isSubmitting: boolean;
  hasCompletedVoting: boolean;
  canNavigateAway: boolean;
  votingError: Error | null;
  data: IBestOf2025VotingResponse | null;
  handleToggleVote: (resourceId: string) => Promise<void>;
  handleRetrySubmit: () => Promise<void>;
  attemptNavigation: (callback: () => void, targetCategoryName?: string) => void;
  pendingTargetCategoryName: string | null;
  // Filters
  clientsFilter: string[];
  setClientsFilter: React.Dispatch<React.SetStateAction<string[]>>;
  companiesFilter: string[];
  setCompaniesFilter: React.Dispatch<React.SetStateAction<string[]>>;
}

export const BestOf2025PhaseTwoResourcesContext = createContext<BestOf2025PhaseTwoResourcesInfo>({
  currentCategory: null,
  setCurrentCategory: () => {},
  categories: [],
  selectedResourceIds: [],
  isSubmitting: false,
  hasCompletedVoting: false,
  canNavigateAway: true,
  votingError: null,
  data: null,
  handleToggleVote: async () => {},
  handleRetrySubmit: async () => {},
  attemptNavigation: () => {},
  pendingTargetCategoryName: null,
  clientsFilter: [],
  setClientsFilter: () => {},
  companiesFilter: [],
  setCompaniesFilter: () => {},
});
